import { authorizationHookFactory } from "./hooks/(beforeRequest)/auth";
import { base } from "./base";
import { errorToastHook } from "./hooks/(beforeError)/errorToast";
import { refreshAuthTokenHook } from "./hooks/(afterResponse)/refreshAuthToken";

const authorizationHook = authorizationHookFactory(() => localStorage.getItem("token"));

// Silent authenticated instance — no loader, auth + 403 refresh only
export const httpAuthBackground = base.extend({
  hooks: {
    afterResponse: [refreshAuthTokenHook],
    beforeError: [errorToastHook],
    beforeRequest: [authorizationHook],
  },
});
